<div class="w-100 h-100 d-flex align-items-center justify-content-center l-root">
  <router-outlet></router-outlet>
</div>
